module.exports = __webpack_public_path__ + "img/second_fw.19d1c0bb.png";